import publisher from '@/api/publisher'
import file from '@/api/file'
import mauthor from '@/api/mauthor'
export default {
  data() {
    return {
      publisher: {},
      article: {
        journal: {}
      },
      id: '',
      questionList: [],
      domain: ''
    }
  },
  mounted() {
    let publisherId = ''
    // if (!location.hostname.includes('192.168')) {
    //   publisherId = location.hostname.split('.')[0]
    // }
    let { id } = this.$route.params
    this.id = id
    this.getPublisherInfo(publisherId || 'imr')
    this.getArticle(id)
    this.getDomain()
  },
  methods: {
    async getPublisherInfo(id) {
      this.publisher = await publisher.query(id)
    },
    async getArticle(id) {
      try {
        this.article = await mauthor.manuscript(id)
        this.questionnaire(this.article.journal.id)
      } catch (e) {
        this.$router.push('/other-author/notice/' + this.id)
      }
    },
    async questionnaire(id) {
      this.questionList = await mauthor.questionnaire(id)
      this.questionList.forEach(item => {
        item.questionId = item.id
        delete item.id
      })
    },
    async getDomain() {
      this.domain = await file.domain()
    },
    async submit() {
      const flag = this.questionList.some(item => {
        if (
          item.type === 'MULTIPLE' &&
          item.checkedOptions &&
          item.checkedOptions.length
        ) {
          item.checkedOption = item.checkedOptions.join(';')
        }
        if (
          item.required &&
          !(item.answer || item.checkedOption || item.checkedOption === 0)
        ) {
          return true
        }
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content: 'Please complete the questionnaire'
        })
        return
      }
      try {
        await mauthor.decision(this.id, {
          status: 'CONFIRMED',
          questionList: this.questionList
        })

        this.$message.success({
          title: 'Success',
          content: 'Thanks for you submit'
        })
      } catch (e) {
        this.$router.push('/other-author/notice/' + this.id)
      }
    }
  }
}
